<template>
  <div :class="['bottom-tab-container', currentTab]">
    <div :class="['play-menu-container', { 'triple-tabs': tabs.length >= 3 }]">
      <ul ref="tabList" role="tablist">
        <li
          v-for="(tab, index) in tabs"
          :key="`bottom_tab_${index}`"
          :class="[tab.type, { on: currentTab === tab.type }]"
          role="tab"
        >
          <a href="javascript:void(0)" @click.prevent="changeTab(tab)">
            <span :data-type="tab.type">{{ tab.title }}</span>
          </a>
        </li>
      </ul>
      <portal-target name="play-filter" class="sub-filter" />
    </div>

    <div class="play-list-container">
      <div
        :class="[
          { 'all-content': currentTab === 'all' || currentTab === 'episode' },
          {
            'content-tab-container':
              currentTab === 'series' ||
              currentTab === 'related' ||
              currentTab === 'recommend',
          },
        ]"
      >
        <!--          fixme: All Content List for Live -->
        <AllContentList
          v-if="currentTab === 'all'"
          :key="`tab-all_content_${$route.fullPath}`"
          :section="section"
          :content-info="contentInfo"
          :landing-info="landingInfo"
        />

        <EpisodeContentList
          v-if="currentTab === 'episode'"
          :key="`tab-all_content_${$route.fullPath}`"
          :section="section"
          :content-info="contentInfo"
          :landing-info="landingInfo"
        />

        <MovieSeriesContentList
          v-if="currentTab === 'series'"
          :key="`movie_series_content_${$route.fullPath}`"
          :content-info="contentInfo"
        />

        <RelatedContentList
          v-if="currentTab === 'related'"
          :key="`tab_related_content_${$route.fullPath}`"
          :section="section"
          :content-info="contentInfo"
          :landing-info="landingInfo"
        />

        <template v-if="currentTab === 'recommend'">
          <RecommendContentList
            v-if="section === 'live'"
            :key="`tab-recommend${$route.fullPath}`"
            :content-info="contentInfo"
            :section="section"
          />
          <RecommendCatalog
            v-else
            :key="`추천탭__${section}`"
            :section="section"
            :content-info="contentInfo"
          />
        </template>
      </div>
    </div>
  </div>
</template>
<script>
  import { get } from 'lodash'
  import VueSticky from 'vue-sticky'
  import AllContentList from '@/components/play/bottom-tab/AllContentList'
  import EpisodeContentList from '@/components/play/bottom-tab/EpisodeContentList'
  import RelatedContentList from '@/components/play/bottom-tab/RelatedContentList'
  import MovieSeriesContentList from '@/components/play/bottom-tab/MovieSeriesContentList'
  import RecommendCatalog from '@/components/play/bottom-tab/RecommendCatalog.vue'
  import RecommendContentList from '@/components/play/bottom-tab/RecommendContentList.vue'

  export default {
    name: 'BottomTabContainer',
    components: {
      RelatedContentList,
      EpisodeContentList,
      AllContentList,
      MovieSeriesContentList,
      RecommendCatalog,
      RecommendContentList,
    },
    directives: {
      VueSticky,
    },
    props: {
      contentInfo: {
        type: Object,
        default: () => {},
      },
      landingInfo: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        section: '', // vod movie live -
        currentTab: '',
        tabs: [],
        bottomTabTopPosition: 0,
      }
    },
    computed: {
      recommendTab() {
        return { type: 'recommend' }
      },
      movieRelatedTab() {
        const hasRelatedVideo =
          Number(get(this.contentInfo, 'countinfo.typeP', '0')) +
            Number(get(this.contentInfo, 'countinfo.typeA', '0')) >
          0
        return hasRelatedVideo ? { type: 'related' } : null
      },
      seriesTab() {
        const { movieseriesid: movieSeriesId = '' } = this.contentInfo
        return movieSeriesId !== '' ? { type: 'series' } : null
      },
      landingTab() {
        return get(this.landingInfo, 'landing_list.tab', [])
      },
      allTab() {
        // for Live
        return { type: 'all' }
      },
    },
    mounted() {
      this.currentTab = get(this.tabs, '0.type', '')
    },
    created() {
      this.section = this.$route.params.section
      this.getTabs()
    },
    methods: {
      moveToBottomTabPosition() {
        if (!this.bottomTabTopPosition) {
          const playerDetailContainer = document.querySelector(
            '.play-detail-container',
          )
          const tabArea = this.$refs.tabList
          const bottomTabContainerTopPadding = 10

          this.bottomTabTopPosition =
            playerDetailContainer.getBoundingClientRect().height -
            (tabArea.getBoundingClientRect().height +
              bottomTabContainerTopPadding)
        }
        window.scrollTo(0, this.bottomTabTopPosition)
      },
      changeTab(tab) {
        this.currentTab = tab.type
        this.moveToBottomTabPosition()
      },
      getTabTitle(tab) {
        const type = get(tab, 'type', '')
        let title = ''
        switch (type) {
          case 'episode':
            title = '에피소드'
            break
          case 'related':
            title = '관련영상'
            break
          case 'recommend':
            title = '추천'
            break
          case 'series':
            title = '시리즈'
            break
          case 'all':
            title = '전체채널'
        }
        return title
      },
      getTabs() {
        let tabList = []
        switch (this.section) {
          case 'movie':
            tabList = [this.movieRelatedTab, this.seriesTab, this.recommendTab]
            break
          case 'vod':
            tabList = [...this.landingTab, this.recommendTab]
            break
          case 'live':
            tabList = [this.allTab, this.recommendTab]
            break
        }
        tabList = tabList.filter((item) => item)
        tabList.map((tab) => {
          Object.assign(tab, { title: this.getTabTitle(tab) })
        })
        this.tabs = tabList
      },
    },
  }
</script>
<style scoped>
  .play-list-container {
    min-height: 221px;
  }
  .play-menu-container {
    width: 100%;
    top: 0;
    z-index: 10;
  }
  .play-menu-container .sub-filter {
    width: 100%;
    background-color: #1b1b1b;
  }

  @media screen and (min-width: 768px) {
    .play-menu-container {
      top: 0;
    }
  }
</style>
